import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  FormControl,
  FormHelperText,
} from '@material-ui/core';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { Cancel, Done } from '@material-ui/icons';
import FilesList from 'components/FilesList';

interface IProps extends DialogProps {
  disabled: boolean;
  onClose(): void;
  onSubmitFile(file: File): void;
}

const validationSchema = yup.object().shape({
  file: yup.mixed().nullable().required('Файл обязателен'),
});

const ReplaceReportFileDialog = ({ disabled, onClose, onSubmitFile, ...props }: IProps) => {
  const initialValues: { file: File | null } = { file: null };

  return (
    <Dialog {...props} onClose={onClose} fullWidth maxWidth="sm" scroll="body">
      <DialogTitle>Заменить файл отчета</DialogTitle>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={({ file }) => onSubmitFile(file!)}
      >
        {({ values, touched, errors, setFieldValue }) => (
          <Form>
            <DialogContent dividers>
              <FormControl fullWidth error={Boolean(touched.file && errors.file)}>
                <FilesList
                  files={values.file ? [values.file] : []}
                  editable={!disabled}
                  width={90}
                  height={90}
                  onChange={(files) => setFieldValue('file', files[0])}
                />

                {touched.file && errors.file && <FormHelperText>{errors.file}</FormHelperText>}
              </FormControl>
            </DialogContent>

            <DialogActions>
              <Button variant="contained" disabled={disabled} onClick={onClose} startIcon={<Cancel />}>
                Отменить
              </Button>

              <Button color="primary" variant="contained" disabled={disabled} type="submit" startIcon={<Done />}>
                Заменить
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default ReplaceReportFileDialog;
